module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("First published in 1998 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("New Holland Publishers (UK) Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This ebook edition published in 2022 by Inkspire.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Inkspire is an imprint of Fox Chapel Publishing,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("903 Square Street, Mount Joy, PA 17552, USA")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.FoxChapelPublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.FoxChapelPublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_vm._v("Copyright © 1998, 2022 Inkspire")]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without prior permission of the publishers and copyright holders.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_vm._v("eISBN 9781913618292")]), _vm._v(" "), _c('p', {
    staticClass: "copy1a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DESIGNED AND EDITED BY")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Complete Editions")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("40 Castelnau")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("London SW13 9RU")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v(": Michèle Brown")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIGNER")]), _vm._v(": Peter Ward")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITORIAL")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTION")]), _vm._v(": Yvonne McFarlane")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("This is a gift book. It is not intended to encourage diagnosis and treatment of illnesses, disease or other general problems by the layman. Any application of the recommendations set out in the following pages is at the reader’s discretion and sole risk.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0